import { render, staticRenderFns } from "./ChangeMailingAddress.vue?vue&type=template&id=21a442c7"
import script from "./ChangeMailingAddress.vue?vue&type=script&lang=js"
export * from "./ChangeMailingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports